export function getInitials(name) {
  const initials = name
    .split(" ")
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase();
  return initials;
}

const getInitialsPlugin = {
  install(app) {
    app.config.globalProperties.$getInitials = getInitials;
  },
};

export default getInitialsPlugin;
